import React, { useEffect, useState } from 'react'
import TransactionTable from '../../../components/transactiontable'
import TrackingTable from '../../../components/trackingtable';
import { getTransactionDetails, getAllRefunding } from '../../../services/medium';
import { useSelector } from 'react-redux';
import Tabs from '../../../components/tabs';
import TabPanel from "../../../components/tabs/tabpanel";
import { setLoading } from "../../../reducer/auth/auth";
import { list } from "./data";

const listHeading = [
    'Session #',
    'Transaction ID',
    'Name',
    'Date',
    'Session Date Time',
    'Payment Method',
    'Amount',
    'Currency'
]
const listHeadingTracking = [
    'Session #',
    'Transaction ID',
    'Name',
    'Refunded Date Time',
    'Session Date Time',
    'Payment Method',
    'Payment Status',
    'Amount',
    'Currency'
]
export default function Transaction() {
    const { id } = useSelector((state) => state.user.user);
    const [transactionsList, setTransactionsList] = useState([]);
    const [trackingList, setTrackingList] = useState([]);
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        getTransactions()
        getRefunding()
    }, [])
const getRefunding = () => {
    let body = {
        medium_id: id,
    }
    getAllRefunding(body).then((data) => {
        console.log(data.data.status, "data")
        if (data.data.status) {
            console.log(data.data.data)
            setTrackingList(data.data.data)

        }
    }).catch(() => { })
}
    const getTransactions = () => {
        let body = {
            medium_id: id,
        }
        getTransactionDetails(body).then((data) => {
            console.log(data.data.status, "data")
            if (data.data.status) {
                console.log(data.data.data)
                setTransactionsList(data.data.data)

            }
        }).catch(() => { })
    }
    return (
       
        <div className="all-medium-page">
        
              <Tabs active={activeTab} list={list} setActiveTab={setActiveTab} />
              <TabPanel id={0} activeTab={activeTab}>
                 <TransactionTable listHeading={listHeading} transactionsList={transactionsList} />
              </TabPanel>
              <TabPanel id={1} activeTab={activeTab}>
                <TrackingTable listHeading={listHeadingTracking} transactionsList={trackingList} />
              </TabPanel>
              
            </div>
    )
}
